import { useEffect, useRef } from 'react';

const useComponentMount = () => {
  const isComponentMounted = useRef(false);

  useEffect(() => {
    isComponentMounted.current = true;
  }, []);

  return isComponentMounted.current;
};

export default useComponentMount;
